/*"idFormulario":"idFormulario",
"nombre":"nombre", 
"tipo":"tipo", 
"nota":"nota", 
"orden":"orden", 
"obligatorio":"obligatorio", 
"validarSeMuestra":"validarSeMuestra", 
"campoSeMuestra":"campoSeMuestra", 
"condicionSeMuestra":"condicionSeMuestra", 
"aviso":"aviso", 

                   
                            <Form.Field  required  error={errors.orden}>            
                              <label  >{strings?strings["orden"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["orden"]:""} 
                                    name="orden"
                                    onChange={onChange}
                                    value={datos.orden}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.obligatorio}>            
                              <label  >{strings?strings["obligatorio"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["obligatorio"]:""} 
                                    name="obligatorio"
                                    onChange={onChange}
                                    value={datos.obligatorio}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.validarSeMuestra}>            
                              <label  >{strings?strings["validarSeMuestra"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["validarSeMuestra"]:""} 
                                    name="validarSeMuestra"
                                    onChange={onChange}
                                    value={datos.validarSeMuestra}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.campoSeMuestra}>            
                              <label  >{strings?strings["campoSeMuestra"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["campoSeMuestra"]:""} 
                                    name="campoSeMuestra"
                                    onChange={onChange}
                                    value={datos.campoSeMuestra}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.condicionSeMuestra}>            
                              <label  >{strings?strings["condicionSeMuestra"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["condicionSeMuestra"]:""} 
                                    name="condicionSeMuestra"
                                    onChange={onChange}
                                    value={datos.condicionSeMuestra}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.aviso}>            
                              <label  >{strings?strings["aviso"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["aviso"]:""} 
                                    name="aviso"
                                    onChange={onChange}
                                    value={datos.aviso}
                                    icon='edit'/>
                            </Form.Field>


*/
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const PreguntaForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, formularioCombo})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Pregunta"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.idFormulario}>            
                              <label  >{strings?strings["idFormulario"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idFormulario"]:""} 
                                    name="idFormulario"
									 fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.idFormulario}
                                    options={formularioCombo}/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.nombre}>            
                              <label  >{strings?strings["nombre"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["nombre"]:""} 
                                    name="nombre"
                                    onChange={onChange}
                                    value={datos.nombre}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.tipo}>            
                              <label  >{strings?strings["tipo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["tipo"]:""} 
                                    name="tipo"
                                    onChange={onChange}
                                    value={datos.tipo}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.nota}>            
                              <label  >{strings?strings["nota"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["nota"]:""} 
                                    name="nota"
                                    onChange={onChange}
                                    value={datos.nota}
                                    icon='edit'/>
                            </Form.Field>
                         
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/preguntas">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default PreguntaForm;